var exports = {};
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numToUint8 = void 0;

function numToUint8(num) {
  return new Uint8Array([(num & 4278190080) >> 24, (num & 16711680) >> 16, (num & 65280) >> 8, num & 255]);
}

exports.numToUint8 = numToUint8; //# sourceMappingURL=numToUint8.js.map

export default exports;